<template>
  <div v-show="isVisible" :class="$style.faq">
    <FaqHero :title="$t('heroTitle')" :subtitle="$t('heroSubtitle')" />
    <div :class="$style.contentWrap">
      <TransitionOnScroll tag="nav" :class="$style.categoryNav" rootMargin="0px 0px -10% 0px">
        <LinkUnderline
          v-for="(category, index) in categories"
          :key="`category-${index}`"
          :class="$style.category"
          :to="category.to"
        >
          {{ category.text }}
        </LinkUnderline>
      </TransitionOnScroll>
      <TransitionOnScroll rootMargin="0px 0px -10% 0px">
        <NuxtChild />
      </TransitionOnScroll>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { ROUTE_NAMES } from '@/constants/route-names'
import FaqHero from '@/components/Faq/FaqHero.vue'
import LinkUnderline from '@/components/Link/LinkUnderline.vue'
import TransitionOnScroll from '@/components/TransitionOnScroll.vue'

export default {
  name: 'FAQ',
  components: {
    FaqHero,
    LinkUnderline,
    TransitionOnScroll,
  },

  data() {
    return {
      ROUTE_NAMES,
    }
  },

  computed: {
    ...mapState('page', ['isVisible']),

    categories() {
      const getTo = name => this.localePath(name)
      return [
        { text: this.$t('categoryService'), to: getTo(ROUTE_NAMES.faq.index) },
        { text: this.$t('categorySecurity'), to: getTo(ROUTE_NAMES.faq.security) },
        { text: this.$t('categoryGeneral'), to: getTo(ROUTE_NAMES.faq.general) },
      ]
    },
  },

  mounted() {
    this.showPage()
  },

  methods: {
    ...mapActions({
      showPage: 'page/show',
    }),
  },
}
</script>

<style lang="scss" module>
@import '@/components/Header/header-settings';

.faq {
  background-color: $color-white;
  width: 100%;
  transition: opacity 0.3s;
}

.contentWrap {
  @include header-padding-x;
  margin: 145px auto 0;
  max-width: 800px;
  box-sizing: content-box;

  @include min-screen($mq-large) {
    margin-top: 160px;
  }
}

.categoryNav {
  display: flex;
  justify-content: center;
}

.category {
  margin: 0 5px;
  padding: 15px;
  color: $color-brand-navy;
  font-size: $font-size-smaller;
  font-weight: bold;
  letter-spacing: $letter-spacing-uppercase;
  text-transform: uppercase;

  &:global(.nuxt-link-exact-active) {
    color: $color-brand-coral-text-dark;
  }

  @include min-screen($mq-small) {
    margin: 0 15px;
  }
}
</style>

<i18n src="@/locales/faq-layout.json" />
